// ✅ src/api.js
import axios from "axios";

//export const BASE_URL = "https://bharatparikhsa-backend.onrender.com/api";

// ✅ Axios instance
const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
});


// 🟢 PDF EXTRACTOR BACKEND (Flask)
// example: http://localhost:5001
export const pdfAPI = axios.create({
  baseURL: process.env.REACT_APP_PDF_API_URL,
});


// ✅ Interceptor to automatically add JWT token from localStorage
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // ya jahan tu token store karta hai
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default API;
